
import History from './history';
import math from './math';

export default {
	History,
	math
};
